import "./styles.scss";
import { applyFormat } from "@wordpress/rich-text";
import {
  useState, useEffect, useRef, useCallback,
} from '@wordpress/element'
import {
  Toolbar, Popover,
} from '@wordpress/components'
import { registerFormatType } from '@wordpress/rich-text';
import { BlockControls, RichTextToolbarButton } from '@wordpress/block-editor';
import { __ } from "@wordpress/i18n";
import ThemeColorSelect from "~buildable/components/theme-color-select";

const edit = props => {
  const {
    activeAttributes,
    isActive,
    onChange,
    value
  } = props;

  const selectValue = isActive ? activeAttributes.class : null;

  const [isOpen, setIsOpen] = useState(false);
  const popoverEl = useRef(null);
  const clickOutsideListener = useCallback(event => {
    if (isOpen && !event.target.closest(popoverEl.current) && !event.target.closest(".components-popover")) {
      setIsOpen(false);
    }
  });

  // Assign the outside click listener.
  useEffect( () => {
    document.body.addEventListener( 'click', clickOutsideListener )
    return () => document.body.removeEventListener( 'click', clickOutsideListener )
  }, [ clickOutsideListener ] );

  const changeTextColor = color => {
    console.log(value, color);

    return applyFormat(
      value,
      {
        type: "buildable/theme-text-color-format",
        attributes: {
          class: color
        }
      }
    );
  }

  return (
    <BlockControls>
      <Toolbar className="theme-text-color-format">
        <RichTextToolbarButton
          icon="editor-textcolor"
          title="Text Color"
          onClick={ () => setIsOpen(true) }
        />
        { isOpen && (
          <Popover
            className="theme-text-color-format-popover"
            position="bottom center"
            focusOnMount="container"
            useRef={ popoverEl }
          >
            <ThemeColorSelect
              className="text-color"
              label={ __("Color") }
              value={ selectValue }
              onChange={ val => onChange(changeTextColor(val)) }
              addPlaceholderOption
            />
          </Popover>
        ) }
      </Toolbar>
    </BlockControls>
  )
};

registerFormatType(
  "buildable/theme-text-color-format", {
    title: "Text Color",
    tagName: "span",
    className: "text-color",
    edit,
  }
);
